import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;

export const useClinics = () => {
  const [clinics, setClinics] = useState(cache || []);
  useEffect(() => {
    if (cache) return;
    api.get("/clinics").then((r) => { cache = r.data; setClinics(r.data); });
  }, []);
  return clinics;
};
